import { css } from "@emotion/react";
import { Link, useParams } from "react-router-dom";
import { useTailwindMediaQueries } from "@/hooks/useTailwindMediaQueries";
import type { Catalog } from "../../../hooks/useCatalogState";
import {
	type ProductCategory,
	type ProductDepartment,
	type ProductSubCategory,
	useInventoryState,
} from "../../../hooks/useInventoryState";
import { useIsDesktopMediaQuery } from "../../../hooks/useIsDesktopMediaQuery";
import { useThemeState } from "../../../hooks/useThemeState";

//-------------------------------------------------------------------------------------------------------
export type SubCategoryControlProps = {
	catalog: Catalog;
	department: ProductDepartment;
	category: ProductCategory;
	subCategory: ProductSubCategory;
	isParentFilterActive: boolean;
};
export const SubCategoryControl: React.FC<SubCategoryControlProps> = (
	props,
) => {
	const mediaQueries = useTailwindMediaQueries();
	const theme = useThemeState().get().theme;
	const inventoryState = useInventoryState();
	const { subcategoryid } = useParams();

	const url = `/inventory/${props.catalog.Id}/${props.department.Id}/${props.category.Id}/${props.subCategory.Id}`;

	// Check if this subcategory is selected based on URL parameters
	const isSelected = subcategoryid === props.subCategory.Id;

	const isDesktop = useIsDesktopMediaQuery();

	return (
		<div
			key={props.subCategory.Id}
			css={css`display:flex;flex-wrap:wrap;align-items:center;margin:.25em 0 0 14px;padding: 0 0 0 8px;border-left: 1px dotted #aaaaaa;`}
		>
			<div
				css={css`
                flex:1 1 0;
                cursor:pointer;
                color: ${isSelected ? theme.palette.siteSideBarContrastText : theme.palette.siteSideBarText};
                &:hover {
                    text-decoration: underline;
                }`}
			>
				<Link
					to={url}
					css={css`
                        flex:1 1 0;
                        cursor:pointer;
                        color: ${isSelected ? theme.palette.siteSideBarContrastText : theme.palette.siteSideBarText};
                        text-decoration: none;
                        display: flex;
                        align-items: center;
                        &:hover {
                            text-decoration: underline;
                        }`}
					onClick={() => {
						return Promise.resolve().then(() => {
							// Clear search text when subcategory is clicked since they're mutually exclusive
							inventoryState.clearSearchTextAsync();
							if (!isDesktop) {
								inventoryState.setSidebarExpanded(false);
							}
						});
					}}
				>
					<span
						css={css`padding: ${mediaQueries.desktop ? "0" : "4px"} 0 ${mediaQueries.desktop ? "0" : "4px"} 4px;font-size:${mediaQueries.desktop ? ".8rem" : "1rem"};`}
					>
						{props.subCategory.Name}
					</span>
				</Link>
			</div>
		</div>
	);
};
